module.exports = __webpack_public_path__ + "img/profile-photo.320fac66.png";